import {MuWidget} from "mu-widget/lib/MuWidget";
import {ColumnInfo, UiTable} from "../components/UiTable";
import {formatDate} from "../Utils";
import {UiDms} from "./UiDms";
import {BaseModule} from "./BaseModule";
import {BaseEditor, formGroup} from "../BaseEditor";
import {BaseFilter} from "./BaseFilter";
import {UiDocumentListPreview} from "./UiDocumentListPreview";
import {ContractFilter, EContractFilter, OrgProject} from "./Types";
import {TreeSelector} from "../TreeSelector";

export class UiDmsOrgProjects extends BaseModule
{
	public contractFilter: EContractFilter = "";

	beforeIndex() {
		super.beforeIndex();
		this.muAppendContent(`
			<h2 mu-id="label">Seznam projektů</h2>
			<div class="toolbar">
				<span class="btn btn-link icon-before-reload" mu-id="bReload">Obnovit</span>
				<span class="btn btn-link icon-before-filter" mu-id="bFilter">Celý filtr <span mu-id="filterCount" class="badge"></span></span>
				<span class="btn btn-link icon-before-erase" mu-id="bFilterErase">Zrušit filtr</span>
				<span class="btn btn-link icon-before-document-sheet" mu-id="bExport">Export</span>
				<input type="search" class="form-control flex-grow-1" mu-id="cFulltext" mu-keybind="Enter:bFulltextSearch" />
				<span class="btn btn-link icon-before-search" mu-id="bFulltextSearch">Vyhledat</span>
			</div>
			<table mu-id="list" mu-widget="UiTable" class="table table-hover table-sticky-header">
				<tr mu-id="templates">
					<td mu-template="actions" mu-widget="UiOrgProjectsActionCell">
						<span mu-id="bDocuments" class="a icon-before-document-dir">Dokumenty</span>
					</td>
				</tr>
			</table>
			
			<div mu-id="pager" mu-widget="UiPager"></div>
			` + (UiDms.instance.isAdmin ? '<a href="/dms/projects-import">Import projektů</a>' : '')
		);
	}

	afterIndex() {
		super.afterIndex();
		this.muNamedWidget.list.columns = [
			// new ColumnInfo({field: "id", name: "ID", filterable: false}),
			new ColumnInfo({field: "name", name: "Název"}),
			new ColumnInfo({field: "code", name: "Kód"}),
			new ColumnInfo({field: "orgDivision", name: "Středisko", orderable: true, filterable: true, template: "shared:documentLinkCell"}),
			new ColumnInfo({field: "id", name: "-", template: "ancestor:actions", orderable: false, filterable: false, interactiveOnly: true}),
		];
	}

	// @ts-ignore
	protected openEditor(id: number|null): BaseEditor {
	}

	protected getListData(forExport: boolean): Promise<any>
	{
		return UiDms.instance.cl.allOrgProjects(
			{ ...this.filter, fulltext: this.ui.cFulltext.value },
			this.orderBy,
			forExport ? 0 : this.muNamedWidget.pager.currentItemFrom,
			forExport ? null : this.muNamedWidget.pager.itemPerPage,
		);
	}

	protected openFilter(field: string|null): UiDmsOrgProjectsFilter {
		const filter = this.muParent.openInModal<UiDmsOrgProjectsFilter>(
			'UiDmsOrgProjectsFilter',
			'Nastavit filtr',
			{ muParent: this }
		);

		return filter;
	}

}

export class UiOrgProjectsActionCell extends MuWidget {
	// @ts-ignore
	private id: number;
	// @ts-ignore
	private row: OrgProject;

	render(id: number, row: any) {
		this.id = id;
		this.row = row;
	}

	bDocuments_click() {
		const listPreview = UiDms.instance.openInModal<UiDocumentListPreview>('UiDocumentListPreview', "...");
		listPreview.showFor("OrgProject", this.id, this.row);
	}
}

export class UiDmsOrgProjectsFilter extends BaseFilter // MuWidget<UiBuSubjects>
{
	beforeIndex() {
		this.muAppendContent(`
			<div mu-id="searchFields">`
			+  formGroup('name', 'Název',
			`<input type="text" mu-bind="name" class="form-control" />`,
			true
			)
			+  formGroup('code', 'Kód',
				`<input type="text" mu-bind="Kód" class="form-control" />`,
				true
			)
			+ formGroup('orgDivision', 'Středisko',
			`<div mu-widget="TreeSelector" mu-id="orgDivision" mu-bind="orgDivision" mu-params='{"inModal":true,"multiple":true,"useModalClass":false}'></div>`,
			true
			)
			+ `</div>
			<div class="buttons">
				<span class="btn btn-primary" mu-id="bFilter">Filtrovat</span>
				<span class="btn btn-warning" mu-id="bClearFilter">Zrušit filtr</span>
			</div>
		`);
	}

	async afterIndex() {
		super.afterIndex();
		(this.muNamedWidget.orgDivision as unknown as TreeSelector).bindTree(
			await UiDms.instance.cpOrgDivision.fetch()
		);
	}


	public static filtredFields(filterData: any): string[] {
		return Object.keys(filterData).filter(f => {
			const v = filterData[f];
			if (Array.isArray(v))
				return v.length > 0;
			else
				return !!v;
		});
	}
}




